import React, { FC } from "react";
import { IconButton } from "@evergis/ui";

import { useDialogReset } from "../../../hooks/useDialogs";

export const CloseDialogIcon: FC = () => {
  const closeDialog = useDialogReset();

  return <IconButton kind={"close"} onClick={closeDialog} />;
};
